import {Box, Card, Grid, Link, Stack, Typography} from "@mui/material";
import {Container} from "@mui/system";
import {useLocales} from "../../locales";
import Iconify from "../Iconify";
import useResponsive from "../../hooks/useResponsive";
import Image from "../image";
import TermsOfUseDialog from "../TermsOfUseDialog";
import {useState} from "react";
import PolicyDialog from "../PolicyDialog";
import {handleCloseTerms, handleOpenTerms} from "../../helper/termsFunction";
import OUPPage from "../../pages/OUPPage";
import {useNavigate} from "react-router-dom";
import {PATH_DASHBOARD} from "../../routes/path";

export default function Footer() {
    const {translate} = useLocales();
    const navigate = useNavigate();
    const [openTermsOfUseOrPolicy, setOpenTermsOfUseOrPolicy] = useState({
        termsOfUse: false,
        policy: false,
    });
    const isMobile = useResponsive("down", "sm");

    const handleClose = () => {
        setOpenTermsOfUseOrPolicy(handleCloseTerms());
    };

    return (
        <Card
            sx={{

                backgroundImage: 'url("/assets/images/header.png")',
                backgroundSize: "cover",
                backgroundPosition: "center",
                width: "100%",
                borderRadius: 0,
                py: 5,
            }}
        >
            <Container maxWidth="xl">
                {!isMobile ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                            <Typography
                                sx={{
                                    color: "white",
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    lineHeight: "1.5",
                                }}
                            >
                                Autobuska stanica "Novi Sad" <br/>
                                21000 Novi Sad, Bulevar Jaše Tomića 6 <br/>
                                <br/>
                                Kontakt: <br/>
                                <a
                                    href="mailto:buska@gspns.rs"
                                    style={{color: "white", textDecoration: "none"}}
                                >
                                    buska@gspns.rs
                                </a>{" "}
                                <br/>
                                021/444-022
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            sx={{
                                display: "flex",
                                flex: 1,
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    mb: 2,
                                    backgroundImage: 'url("/assets/images/buska-logo.png")',
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    height: "37px",
                                    width: "91px",
                                    borderRadius: 0,
                                    flexShrink: 0,
                                }}
                            />
                            <Stack direction="row" spacing={1.2}>
                                <Link
                                    noWrap
                                    underline="none"
                                    component="button"
                                    onClick={() => setOpenTermsOfUseOrPolicy(handleOpenTerms(0))}
                                    sx={{
                                        fontFamily: "Montserrat",
                                        fontSize: 13,
                                        typography: "body2",
                                        color: "white",
                                        transition: (theme) => theme.transitions.create("all"),
                                        "&:hover": {color: "primary.main"},
                                    }}
                                >
                                    {translate("termsOfUse")}
                                </Link>
                                <Link
                                    noWrap
                                    underline="none"
                                    component="button"
                                    onClick={() => setOpenTermsOfUseOrPolicy(handleOpenTerms(1))}
                                    sx={{
                                        fontFamily: "Montserrat",
                                        fontSize: 13,
                                        typography: "body2",
                                        color: "white",
                                        transition: (theme) => theme.transitions.create("all"),
                                        "&:hover": {color: "primary.main"},
                                    }}
                                >
                                    {translate("privatePolicy")}
                                </Link>
                                <Link
                                    noWrap
                                    underline="none"
                                    component="button"
                                    onClick={() => navigate(PATH_DASHBOARD.general.oup)}
                                    sx={{
                                        fontFamily: "Montserrat",
                                        fontSize: 13,
                                        typography: "body2",
                                        color: "white",
                                        transition: (theme) => theme.transitions.create("all"),
                                        "&:hover": {color: "primary.main"},
                                    }}
                                >
                                    {translate("OUP")}
                                </Link>
                            </Stack>
                            <br/>
                            <Typography
                                sx={{
                                    color: "white",
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    lineHeight: "1.5",
                                }}
                            >
                                Javno gradsko saobraćajno preduzeće Novi Sad
                            </Typography>
                            <Typography
                                sx={{
                                    color: "white",
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    lineHeight: "1.5",
                                }}
                            >
                                21000 Novi Sad, Futoški put 46
                            </Typography>
                            <Typography
                                sx={{
                                    color: "white",
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    lineHeight: "1.5",
                                }}
                            >
                                PIB: 100277648
                            </Typography>
                            <Typography
                                sx={{
                                    color: "white",
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    lineHeight: "1.5",
                                }}
                            >
                                MB: 08041822
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            sx={{
                                display: "flex",
                                flex: 1,
                                flexDirection: "column",
                                textAlign: "right",
                            }}
                        >
                            <Stack spacing={2}>
                                <Stack
                                    direction="row"
                                    spacing={1.2}
                                    alignItems="center"
                                    justifyContent="flex-end"
                                    component="a"
                                    href="https://www.instagram.com/jgspnovi_sad/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        textDecoration: "none",
                                        "&:hover": {
                                            textDecoration: "none",
                                        },
                                    }}
                                >
                                    <Iconify
                                        color="white"
                                        icon="mdi:instagram"
                                        width={17}
                                        sx={{mr: 1.5}}
                                    />
                                    <Typography
                                        sx={{
                                            alignItems: "center",
                                            color: "white",
                                            fontFamily: "Montserrat",
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                        }}
                                    >
                                        INSTAGRAM
                                    </Typography>
                                </Stack>
                                <Stack
                                    direction="row"
                                    spacing={1.2}
                                    alignItems="center"
                                    justifyContent="flex-end"
                                    component="a"
                                    href="https://www.facebook.com/JgspNoviSad/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        textDecoration: "none",
                                        "&:hover": {
                                            textDecoration: "none",
                                        },
                                    }}
                                >
                                    <Iconify
                                        color="white"
                                        icon="ant-design:facebook-outlined"
                                        width={17}
                                        sx={{mr: 3}}
                                    />
                                    <Typography
                                        sx={{
                                            color: "white",
                                            fontFamily: "Montserrat",
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                        }}
                                    >
                                        FACEBOOK <br/>
                                    </Typography>
                                </Stack>
                                <Typography
                                    sx={{
                                        alignItems: "center",
                                        color: "white",
                                        fontFamily: "Montserrat",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        lineHeight: "normal",
                                    }}
                                >
                                    © 2024 JGSP Novi Sad
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                ) : (
                    <Box
                        sx={{
                            display: "flex",
                            flex: 1,
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                        }}
                    >
                        <Image
                            sx={{width: 91, height: 37}}
                            alt="appStore"
                            src="/assets/images/logo.png"
                        />
                        <Stack direction="row" spacing={1.2}>
                            <Link
                                noWrap
                                underline="none"
                                component="button"
                                onClick={() => setOpenTermsOfUseOrPolicy(handleOpenTerms(0))}
                                sx={{
                                    textDecoration: "none",
                                    fontFamily: "Montserrat",
                                    fontSize: 13,
                                    typography: "body2",
                                    color: "white",
                                    transition: (theme) => theme.transitions.create("all"),
                                    "&:hover": {color: "primary.main"},
                                }}
                            >
                                {translate("termsOfUse")}
                            </Link>
                            <Link
                                noWrap
                                underline="none"
                                component="button"
                                onClick={() => setOpenTermsOfUseOrPolicy(handleOpenTerms(1))}
                                sx={{
                                    fontFamily: "Montserrat",
                                    fontSize: "12px",
                                    typography: "body2",
                                    color: "white",
                                    transition: (theme) => theme.transitions.create("all"),
                                    "&:hover": {color: "primary.main"},
                                }}
                            >
                                {translate("privatePolicy")}
                            </Link>
                            <Link
                                noWrap
                                underline="none"
                                component="button"
                                onClick={() => navigate(PATH_DASHBOARD.general.oup)}
                                sx={{
                                    fontFamily: "Montserrat",
                                    fontSize: "12px",
                                    typography: "body2",
                                    color: "white",
                                    transition: (theme) => theme.transitions.create("all"),
                                    "&:hover": {color: "primary.main"},
                                }}
                            >
                                {translate("OUP")}
                            </Link>
                        </Stack>

                        <Typography
                            sx={{
                                color: "white",
                                fontFamily: "Montserrat",
                                fontSize: "12px",
                                fontWeight: 400,
                                lineHeight: "normal",
                            }}
                        >
                            © 2023 JGSP Novi Sad
                        </Typography>
                    </Box>
                )}
            </Container>
            <Box
                sx={{
                    mt: 4,
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.75)",
                    padding: 2,

                }}
            >
                <Stack
                    direction="row"
                    spacing={3}
                    alignItems="center"
                    sx={{flexWrap: "wrap", justifyContent: "center", rowGap: 3}}
                >
                    <Box className="payment-logo" sx={{filter: "brightness(0.9)"}}>
                        <img
                            src={`/assets/payment/visa.png`}
                            alt="Visa"
                            style={{height: 40}}
                        />
                    </Box>
                    <Box className="payment-logo" sx={{filter: "brightness(0.9)"}}>
                        <img
                            src={`/assets/payment/dina.jpg`}
                            alt="Pay Logo 2"
                            style={{height: 40}}
                        />
                    </Box>
                    <Box className="payment-logo" sx={{filter: "brightness(0.9)"}}>
                        <img
                            src={`/assets/payment/master.png`}
                            alt="Mastercard"
                            style={{height: 40}}
                        />
                    </Box>
                    <Box className="payment-logo" sx={{filter: "brightness(0.9)"}}>
                        <img
                            src={`/assets/payment/maestro.png`}
                            alt="Mastercard"
                            style={{height: 40}}
                        />
                    </Box>
                    <Box className="payment-logo" sx={{filter: "brightness(0.9)"}}>
                        <img
                            src="https://www.payspot.rs/wp-content/uploads/2020/03/payspotrs-logo.png"
                            alt="Payspot"
                            style={{height: 40}}
                        />
                    </Box>
                    <Box className="payment-logo" sx={{filter: "brightness(0.9)"}}>
                        <img
                            src={`/assets/payment/visasecure.jfif`}
                            alt="Payspot"
                            style={{height: 40}}
                        />
                    </Box>
                    <Box className="payment-logo" sx={{filter: "brightness(0.9)"}}>
                        <img
                            src={`/assets/payment/idcheck.jfif`}
                            alt="Payspot"
                            style={{height: 40}}
                        />
                    </Box>
                </Stack>
            </Box>


            {openTermsOfUseOrPolicy.termsOfUse && (
                <TermsOfUseDialog
                    open={openTermsOfUseOrPolicy.termsOfUse}
                    handleClose={handleClose}
                />
            )}
            {openTermsOfUseOrPolicy.policy && (
                <PolicyDialog
                    open={openTermsOfUseOrPolicy.policy}
                    handleClose={handleClose}
                />
            )}
            {openTermsOfUseOrPolicy.oup && (
                <OUPPage
                />
            )}
            <Stack direction="row" spacing={1.2} width={1} justifyContent="center" alignItems="center">
                <Typography
                    sx={{
                        color: "white",
                        fontFamily: "Montserrat",
                        fontWeight: 400,
                        lineHeight: "normal",
                        fontSize: 13,
                        textAlign: "center",
                    }}
                >
                    {translate("reCaptchaText")}
                    <Link
                        noWrap
                        underline="none"
                        sx={{
                            fontFamily: "Montserrat",
                            fontSize: 13,
                            typography: "body2",
                            color: "white",
                            transition: (theme) => theme.transitions.create("all"),
                            "&:hover": { color: "primary.main" },
                        }}
                        href="https://policies.google.com/privacy"
                    >
                        {translate("privatePolicy")}
                    </Link> {translate("and")}  <Link
                    noWrap
                    underline="none"
                    sx={{
                        fontFamily: "Montserrat",
                        fontSize: 13,
                        typography: "body2",
                        color: "white",
                        transition: (theme) => theme.transitions.create("all"),
                        "&:hover": { color: "primary.main" },
                    }}
                    href="https://policies.google.com/terms"
                >
                    {translate("termsOfUse")}
                </Link>

                </Typography>
            </Stack>

        </Card>
    );
}
